import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppPublicRoutingModule } from './app-public-routing.module';
import { AppPublicComponent } from './app-public.component';
import { VisualIdentificationModule } from './visual-identification/visual-identification.module';
import { SharedModule } from '@shared/shared.module';
import { ServiceProxyModule } from '@shared/service-proxies/service-proxy.module';
import { StaffMapTrackingModule } from './staff-map-tracking/staff-map-tracking.module';
import { StaffMapTrackingServiceProxy } from '@shared/service-proxies/service-proxies';
import { TestModule } from 'test/test.module';


@NgModule({
  declarations: [    
    AppPublicComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    AppPublicRoutingModule,
    VisualIdentificationModule,
    StaffMapTrackingModule,
    TestModule,
    ServiceProxyModule,
  
  ],
  bootstrap: [AppPublicComponent],
  providers: [StaffMapTrackingServiceProxy]
})
export class AppPublicModule { }
